import { Heading } from 'blaze-ui/Heading/Heading'
import { GROUPS } from './constants'
import Styles from './DesignAspectRatioPickerModal.module.scss'
import { GroupsProps } from './Types'
import { AspectRatio } from './AspectRatio'
import { ASPECT_RATIOS } from 'components/NewFileModal/Types'

export const Groups = ({ onSelect }: GroupsProps) => (
  <div className={Styles.groups}>
    {GROUPS.map((group) => (
      <div className={Styles.group} key={group.name}>
        <Heading level={5}>{group.name}</Heading>
        <div className={Styles.list}>
          {group.aspectRatios.map((key) => (
            <AspectRatio key={key} onSelect={() => onSelect(key)} {...ASPECT_RATIOS[key]} />
          ))}
        </div>
      </div>
    ))}
  </div>
)
